import React from 'react';
import { useNavigate } from 'react-router-dom';
import './issuesCheck.scss';


export const IssuesToCheck = () => {
  const navigate = useNavigate();


  const threatCards1 = ['40% increase  in Malware Sites mitigated.', '63% increase in Major viruses mitigated.', '54% increase in Phishing Threats Blocked.', '38% increase in Spam Generators mitigated.'];
  const threatCards2A = ['5 devices with Critical Vulnerability CVE-2016-6691'];
  const threatCards2B = ['12 devices with High Vulnerability CVE-2016-2497'];
  const threatCards3A = ['Current Version of CPE Agent is 1.2.3', '1 units running Version 1.0.0', '4 units running Version 1.1.0'];
  const threatCards3B = ['1 CPE Unit has not been seen for more than 30 days', '1 CPE Unit has not been seen for more than 60 days'];
  const threatCards4 = ['Current Version of the Mobile Application is 1.3.2', '1 mobile is running Version 1.1.2', '3 mobiles are running Version 1.2.1', '12 mobiles are running Version 1.3.0'];

  return (
    <div className="container">
      <section className={`retina-widget container`}>
        <h1 className='header-title'>Issues to Check</h1>
        <div className="flex justify-around gap-5">
          <div className="card-warning col-6 my-5 p-5">
            <div className="flex align-items-start gap-3 mb-11">
              <img src="/icons/warning-neon-red.svg" alt="Warning Icon" />
              <span className="box-text">Significant Increase in Threats Todays'</span>
            </div>

            <div className="threats-mitigated-panel px-10 py-8 relative">
              <div className="flex flex-col gap-3" style={{ width: '100%' }}>
                {threatCards1.map((threat, index) => (
                  <div key={index} className="threatBox">
                    <div className="threat-card">{threat}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="card-warning col-6 my-5 p-5">
            <div className="flex align-items-start gap-3 mb-11">
              <img src="/icons/warning-neon-red.svg" alt="Warning Icon" />
              <span className="box-text">Critical and High Vulnerabilities</span>
            </div>

            <div className="flex flex-col gap-3">
              <div className="threats-mitigated-panel px-10 py-8 relative">
                <div className="flex flex-col gap-3" style={{ width: '100%' }}>
                  {threatCards2A.map((threat, index) => (
                    <div key={index} className="threatBox">
                      <div className="threat-card">{threat}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="threats-mitigated-panel px-10 py-8 relative">
                <div className="flex flex-col gap-3" style={{ width: '100%' }}>
                  {threatCards2B.map((threat, index) => (
                    <div key={index} className="threatBox">
                      <div className="threat-card">{threat}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-around gap-5">
          <div className="card-alert col-6 my-5 p-5">
            <div className="flex align-items-start gap-3 mb-11">
              <img src="/icons/warning-neon-red.svg" alt="Warning Icon" />
              <span className="box-text">There are Mobiles with Outdated Applications</span>
            </div>

            <div className="flex flex-col gap-3">
              <div className="threats-mitigated-panel px-10 py-8 relative">
                <div className="flex flex-col gap-3" style={{ width: '100%' }}>
                  {threatCards3A.map((threat, index) => (
                    <div key={index} className="threatBox">
                      <div className="threat-card">{threat}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="threats-mitigated-panel px-10 py-8 relative">
                <div className="flex flex-col gap-3" style={{ width: '100%' }}>
                  {threatCards3B.map((threat, index) => (
                    <div key={index} className="threatBox">
                      <div className="threat-card">{threat}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="card-alert col-6 my-5 p-5">
            <div className="flex align-items-start gap-3 mb-11">
              <img src="/icons/warning-neon-red.svg" alt="Warning Icon" />
              <span className="box-text">There are Issues on CPE Units</span>
            </div>

            <div className="threats-mitigated-panel px-10 py-8 relative">
              <div className="flex flex-col gap-3" style={{ width: '100%' }}>
                {threatCards4.map((threat, index) => (
                  <div key={index} className="threatBox">
                    <div className="threat-card">{threat}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};
